/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ChargeType = "dynamic" | "static" | "%future added value";
export type Api_service = {
    readonly id: string;
    readonly name: string;
    readonly description: string;
    readonly imageURL: string;
    readonly secret: string | null;
    readonly supportedCurrencies: ReadonlyArray<string>;
    readonly supportableCurrencies: ReadonlyArray<string>;
    readonly charges: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string;
                readonly description: string;
                readonly chargeIdentifier: string;
                readonly chargeType: ChargeType;
                readonly prices: ReadonlyArray<{
                    readonly amount: number;
                    readonly currency: string;
                }>;
            } | null;
        } | null> | null;
    } | null;
    readonly devSubscription: {
        readonly secret: string | null;
    } | null;
    readonly " $refType": "Api_service";
};
export type Api_service$data = Api_service;
export type Api_service$key = {
    readonly " $data"?: Api_service$data;
    readonly " $fragmentRefs": FragmentRefs<"Api_service">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secret",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after30"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after7"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "afterYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before30"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before7"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "beforeYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Api_service",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageURL",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportedCurrencies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportableCurrencies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChargeConnection",
      "kind": "LinkedField",
      "name": "charges",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChargeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Charge",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "chargeIdentifier",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "chargeType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Price",
                  "kind": "LinkedField",
                  "name": "prices",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currency",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Subscription",
      "kind": "LinkedField",
      "name": "devSubscription",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Service",
  "abstractKey": null
};
})();
(node as any).hash = '9bde42daaf8d95d028f8e92d9a312e9d';
export default node;
